// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__6a7C_","title":"Images45_title__2cQwO","images":"Images45_images__1QDm2"};